export default __webpack_public_path__ + "static/bike-visual-db853ffa301d2e7334bdb93b6f46769e.svg";